import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CardError, CardMyTurns, Loading } from '../../components';
import { getMyTurns } from '../../redux/actions/turnActions';
import { DOCTORS, TURNS_PATH } from '../../routes/path';
import './index.scss';

const MyTurns = () => {
  const { confirm, isLoading } = useSelector((state) => state.turnReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMyTurns());
  }, []);

  const redirect = () => {
    navigate(`${TURNS_PATH}${DOCTORS}`);
  };

  if (isLoading) return <Loading />;
  if (confirm?.length === 0) {
    return <CardError text="No hay turnos confirmados" />;
  }

  return (
    <div className="container-myTurns">
      <div className="turn-next">
        <p className="tittle-turn-after">Turnos próximos</p>
        {confirm?.futuras?.length === 0 && <p className="no-turns-message">No hay turnos aún</p>}
        <button onClick={redirect} className="button-turn">Nuevo turno</button>
        <div>
          {confirm?.futuras?.map((turn) => (
            <CardMyTurns turn={turn} />
          ))}
        </div>
      </div>
      <div className="turn-before">
        <p className="tittle-turn-before">Turnos pasados</p>
        {confirm?.pasadas?.length === 0 && <p className="no-turns-message">No hay turnos aún</p>}
        <div>
          {confirm?.pasadas?.map((turn) => (
            <CardMyTurns turn={turn} isDisabled />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyTurns;
